// extracted by mini-css-extract-plugin
module.exports = {"username":"BetHistory_username__2C48d","fullName":"BetHistory_fullName__3RYDZ","countryInfo":"BetHistory_countryInfo__2JBzG"};